module.exports = __webpack_public_path__ + "static/media/emmaamarillacompleta.e9e66d7f.png";